import { Theme } from "@mui/material/styles";
import { RootState, useSelector } from "@redux/store";
import { CustomTheme } from "src/@types/customTheme";

// ----------------------------------------------------------------------

export default function Tabs(theme: Theme) {
  const customTheme = useSelector(
    (state: RootState) => state.accountInfo.accountInfo?.customTheme,
  );
  return {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor:
            customTheme === CustomTheme.Sage
              ? theme.palette.sage_green
              : theme.palette.secondary.main,
          height: 4,
        },
        paddimg: "2px",
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: theme.typography.body2,
          fontSize: 13,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          color: theme.palette.text.label,
          "&.Mui-selected": {
            color: theme.palette.secondary.main,
            fontWeight: theme.typography.fontWeightBold,
          },
          "&:not(:last-of-type)": {
            marginRight: theme.spacing(2),
          },
          "@media (min-width: 600px)": {
            minWidth: 48,
          },
        },
        labelIcon: {
          minHeight: 32,
          flexDirection: "row",
          "& > *:first-of-type": {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: "row",
          whiteSpace: "nowrap",
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: "50%",
        },
      },
    },
  };
}
